import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addblog, updateblog } from '../redux-toolkit/Slice/blogSlice';
import { POST_blog, PUT_blog } from '../redux-toolkit/ApiEndpoint';

const Blogedit = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [value, setValue] = useState('');
    const [title, setTitle] = useState('');
    const [image, setImage] = useState(null);
    const [editingBlog, setEditingBlog] = useState(null);

    const { blogdata } = useSelector(state => state.blog);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const editUuid = queryParams.get('edit');

        if (editUuid) {
            const blogToEdit = blogdata.find(blog => blog.uuid === editUuid);
            if (blogToEdit) {
                setEditingBlog(blogToEdit);
                setTitle(blogToEdit.title);
                setValue(blogToEdit.content); // Set the Quill content
                setImage(null); // You may want to load image later if needed, but for now it's left as null
            }
        }
    }, [location, blogdata]);

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            ['link', 'image', 'video', 'formula'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean']
        ]
    };

    const handleImageChange = (e) => setImage(e.target.files[0]);

    const handleSubmit = () => {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('image', image);
        formData.append('content', value); // Store the HTML formatted content

        if (editingBlog) {
            try {
                dispatch(updateblog({
                    endpoint: PUT_blog,
                    uuid: editingBlog.uuid,
                    payload: formData
                })).unwrap();
                toast.success('Blog updated successfully!');
            } catch (error) {
                toast.error(error || 'Failed to update Blog. Please try again.');
            }
            navigate('/Blog');
        } else {
            try {
                dispatch(addblog({
                    endpoint: POST_blog,
                    payload: formData
                })).unwrap();
                toast.success('Blog added successfully!');
            } catch (error) {
                toast.error(error || 'Failed to add Blog. Please try again.');
            }
            navigate('/Blog');
        }

        resetForm();
    };

    const resetForm = () => {
        setTitle('');
        setImage(null);
        setEditingBlog(null);
    };

    return (
        <main className="page-padding">
            <section className="contact-wrapper p-0">
                <div className="container-fluid">
                    <h2 className="title">{editingBlog ? 'Edit Blog' : 'Create Blog'}</h2>
                    <div className="col-12">
                        <hr />
                    </div>
                    <div className="mb-6">
                        <div className="mb-4">
                            <label htmlFor="title" className="form-label">Blog Title</label>
                            <input
                                type="text"
                                className="form-control"
                                id="title"
                                value={title}
                                placeholder='Blog title'
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div className="mb-4">
                            <label htmlFor="image" className="form-label">Upload Image</label>
                            <input
                                type="file"
                                className="form-control p-3"
                                id="image"
                                onChange={handleImageChange}
                            />
                        </div>
                        <div className="mb-4">
                            <ReactQuill
                                theme="snow"
                                value={value}
                                onChange={setValue}
                                modules={modules}
                            />
                        </div>

                        <button onClick={handleSubmit} className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase border border-0">
                            {editingBlog ? 'Update Blog' : 'Create Blog'}
                        </button>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Blogedit;



//  {/* <div dangerouslySetInnerHTML={{ __html: value }} /> */}